import * as yup from 'yup';

const CardSelectionSchema = {
    card_ids: yup.array().of(yup.number()).min(1).required(),
};

export default CardSelectionSchema;
